import { render, staticRenderFns } from "./Statement.vue?vue&type=template&id=7634165b&scoped=true&"
import script from "./Statement.vue?vue&type=script&lang=ts&"
export * from "./Statement.vue?vue&type=script&lang=ts&"
import style0 from "./Statement.vue?vue&type=style&index=0&id=7634165b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7634165b",
  null
  
)

/* custom blocks */
import block0 from "./Statement.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports